import { baseApiCall } from './BaseApiCall'
import { addAddress, addtoCart, createOrder, createProductImages, createProducts, createShopProfile, createVarient, createVarientImages, createWishlist, deleteAddress, deleteCartItem, deleteProductImages, deleteProducts, deleteVarient, deleteVarientImages, getAddress, getAllCategory, getAllColors, getAllGender, getAllProducts, getAllSizes, getBanners, getCart, getNewArrivals, getOrder, getOrderbyId, getplayerdata, getShopDashboard, getShopProfile, getuserdetails, getVenderProducts, getWishlist,login, removeWishlist, updateAddress, updateCartItem, updateProducts, updateVarient, uploadImageFile } from './ApiEndPoint'

export const GetUserInfo = (data: any) => {
  return baseApiCall({
    url: getuserdetails + data,
    method: 'get',
  })
}

export const UserLogin = (data: any) => {
  return baseApiCall({
    url: login,
    method: 'post',
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export const ApigetUserData = (data: any) => {
  return baseApiCall({
    url: getplayerdata + data,
    method: 'get',
  })
}

export const ApiUploadImage = (data: any) => {
  return baseApiCall({
    url: uploadImageFile,
    method: 'post',
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export const ApiCreateShopProfile = (data: any) => {
  return baseApiCall({
    url: createShopProfile,
    method: 'post',
    data
  })
}
export const ApiGetShopProfile = (data?:any) => {
  return baseApiCall({
    url: getShopProfile + data,
    method: 'get',
    skipLoader : true
  })
}
export const ApiGetAllCategory = (data:any = "") => {
  return baseApiCall({
    url: getAllCategory + data,
    method: 'get',
    skipLoader : true
  })
}
export const ApiGetAllGender = () => {
  return baseApiCall({
    url: getAllGender,
    method: 'get',
  })
}

export const ApiGetAllColors = () => {
  return baseApiCall({
    url: getAllColors,
    method: 'get',
    skipLoader : true
  })
}

export const ApiGetAllSizes = () => {
  return baseApiCall({
    url: getAllSizes,
    method: 'get',
    skipLoader : true
  })
}

export const ApiGetAllProducts = (data:any = "") => {
  return baseApiCall({
    url: getAllProducts + data,
    method: 'get',
    skipLoader : Boolean(data?.length > 0),
  })
}

export const ApiCreateProduct = (data:any) => {
  return baseApiCall({
    url: createProducts,
    method: 'post',
    data
  })
}

export const ApiUpdateVarient = (params:any , data:any) => {
  return baseApiCall({
    url: updateVarient + params,
    method: 'put',
    data
  })
}

export const ApiCreateVarient = (data:any) => {
  return baseApiCall({
    url: createVarient,
    method: 'post',
    data
  })
}

export const ApiDeleteVariant = (params:any) => {
  return baseApiCall({
    url: deleteVarient + params,
    method: 'delete',
  })
}

export const ApiGetVenderProducts = (data:any) => {
  return baseApiCall({
    url: getVenderProducts + data,
    method: 'get',
  })
}

export const ApiUpdateProduct = (params:any , data:any) => {
  return baseApiCall({
    url: updateProducts + params,
    method: 'put',
    data
  })
}
export const ApiDeleteProduct = (params:any) => {
  return baseApiCall({
    url: deleteProducts + params,
    method: 'delete',
  })
}
export const ApiCreateProductImages = (data:any) => {
  return baseApiCall({
    url: createProductImages,
    method: 'post',
    data
  })
}
export const ApiDeleteProductImages = (data:any) => {
  return baseApiCall({
    url: deleteProductImages + data,
    method: 'delete',
  })
}
export const ApiDeleteVarinatImages = (data:any) => {
  return baseApiCall({
    url: deleteVarientImages + data,
    method: 'delete',
  })
}
export const ApiCreateVariantImages = (data:any) => {
  return baseApiCall({
    url: createVarientImages,
    method: 'post',
    data
  })
}
export const ApiGetNewArrivals = (data:any) => {
  return baseApiCall({
    url: getNewArrivals + data,
    method: 'get',
    skipLoader : true
  })
}

export const ApiGetBanners = () => {
  return baseApiCall({
    url: getBanners,
    method: 'get',
    skipLoader : true
  })
}

export const ApiAddToWishlist = (data:any) => {
  return baseApiCall({
    url: createWishlist,
    method: 'post',
    data
  })
}
export const ApiGetWishlist = () => {
  return baseApiCall({
    url: getWishlist,
    method: 'get',
  })
}
export const ApiRemoveWishlist = (data:any) => {
  return baseApiCall({
    url: removeWishlist + data,
    method: 'delete',
  })
}

export const ApiAddToCart = (data:any) => {
  return baseApiCall({
    url: addtoCart,
    method: 'post',
    data
  })
}

export const ApiGetCartlist = () => {
  return baseApiCall({
    url: getCart,
    method: 'get',
  })
}

export const ApiUpdateCartlist = (data1:string, data2:any) => {
  return baseApiCall({
    url: updateCartItem + data1,
    method: 'put',
    data:data2,
    skipLoader : true
  })
}
export const ApiDeleteCartitem = (data:string) => {
  return baseApiCall({
    url: deleteCartItem + data,
    method: 'delete',
    skipLoader : true
  })
}



export const ApiAddAddress = (data:any) => {
  return baseApiCall({
    url: addAddress,
    method: 'post',
    data
  })
}

export const ApiGetAddress = () => {
  return baseApiCall({
    url: getAddress,
    method: 'get',
  })
}

export const ApiUpdateAddress = (data1:string, data2:any) => {
  return baseApiCall({
    url: updateAddress + data1,
    method: 'put',
    data:data2,
    skipLoader : true
  })
}
export const ApiDeleteAddress = (data:string) => {
  return baseApiCall({
    url: deleteAddress + data,
    method: 'delete',
    skipLoader : true
  })
}



export const ApiCreateOrder = (data:any) => {
  return baseApiCall({
    url: createOrder,
    method: 'post',
    data
  })
}

export const ApiGetOrders = () => {
  return baseApiCall({
    url: getOrder,
    method: 'get',
    skipLoader : true
  })
}

export const ApiGetOrderById = (data:any= "") => {
  return baseApiCall({
    url: getOrderbyId + data,
    method: 'get',
  })
}

export const ApiGetShopDashboard = (data:any= "") => {
  return baseApiCall({
    url: getShopDashboard + data,
    method: 'get',
    
  })
}

